import { Resume } from "../../models/Resume";

export abstract class IResumeRepository {
    abstract getResume: () => Promise<Resume>;
    abstract getResumeById: (id: string) => Promise<Resume>;
}